<template>
  <div class="retrieve_pass">
    <el-steps :active="currentStep" align-center>
      <el-step title="Retrieve Password" description="">
        
      </el-step>
      <el-step title="Set a new password" description=""></el-step>
    </el-steps>
    <div class="segmentation"></div>
    <ul class="retrieve_content">
      <li v-if="currentStep===1">
        <p class="retrieve_p">Please input the email account to reset your password</p>
        <el-form :model="obj" ref="retrievePassword" :rules="rules" class="demo-dynamic">
          <el-form-item prop="email">
            <el-input v-model="obj.email" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input class="input_Code" v-model="obj.code" placeholder="Input the verification code"></el-input>
            <el-button class="btn_Code" type="primary" @click="sendCode" :disabled="codeFalg">{{countdown}}</el-button>
          </el-form-item>
          <el-form-item class="btnGroup">
            <el-button class="btn" type="primary" @click="submitForm('retrievePassword')">Next Step</el-button>
          </el-form-item>
        </el-form>
      </li>
      <li v-else-if="currentStep===2">
        <p class="retrieve_p">Please set a new password of <span style="color:#008baf">{{obj.email}}</span>. It is recommended to use a combination of numbers, letters and characters to improve the security level of the password</p>
        <el-form :model="obj" ref="retrievePassword1" :rules="rules" class="demo-dynamic">
          <el-form-item prop="pwd">
            <el-input v-model="obj.pwd" placeholder="Input password" show-password></el-input>
          </el-form-item>
          <el-form-item class="btnGroup">
            <el-button class="btn" type="primary" @click="submitForm1('retrievePassword1')">Yes</el-button>
          </el-form-item>
        </el-form>
      </li>
    </ul>
  </div>
</template>

<script>
import { reqRetrieveCode, reqRetrieveCodeTwo, reqNewPwd } from "../../../api";
export default {
  data(){
    var validateEmail = (rule, value, callback)=>{
      if (value === '') {
        this.codeFalg = true
        callback(new Error('Email address is required'));
      } else if(!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)){
        this.codeFalg = true
        callback(new Error('Input email address'));
      } else {
        this.codeFalg = false
        console.log(this.codeFalg);
        callback();
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Input password'));
      } else if(value.length<6||value.length>16){
        callback(new Error('Input a 6-15 digit password'));
      } else {
        callback();
      }
    };
    return{
      currentStep:1,
      obj:{
        email:'',
        code:'',
        pwd:''
      },
      codeFalg:true,
      countdown:'verification code',
      rules:{
        email:[
          { validator: validateEmail, trigger: 'blur' }
        ],
        pwd:[
          { validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    async sendCode(){//发送验证码
      const response = await reqRetrieveCode({email:this.obj.email})
      console.log(response);
      if (response.code*1==1) {
        this.err(this,'Not registered yet')
      }else if(response.code*1==3){
        this.success(this,'Sent successfully')
        this.countdown = 90
        this.codeFalg = true
        this.time()
      }else{
        this.err(this,'Timeout, please try...')
      }
    },
    time(){//倒计时
      this.timer = setInterval(()=>{
        this.countdown--
        if (this.countdown<=0) {
          clearInterval(this.timer)
          this.countdown = "verification code"
          this.codeFalg = false
        }
      },1000)
    },
    submitForm(formName){
      this.$refs[formName].validate( async (valid) => {
        if (valid) {//提交表单数据，发送请求
        const response = await reqRetrieveCodeTwo({email:this.obj.email,code:this.obj.code})
        console.log(response);
        if (response.code*1==2) {
          this.currentStep=2
        }else{
          this.err(this,'Email and verification code are required')
        }
        } else {
          return false;
        }
      })
    },
    submitForm1(formName){
      console.log(this.obj.pwd);
      this.$refs[formName].validate( async (valid) => {
        if (valid) {//提交表单数据，发送请求
          const response = await reqNewPwd({pwd:this.obj.pwd})
          console.log(response);
          if (response.code*1==2) {
            this.success(this,'Modified successfully')
            this.$router.push('/home')
            this.$store.dispatch("dialog",true)
          }else{
            this.err(this,'新密码设置失败,请稍后重试...')
          }
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<style scoped>
  .retrieve_pass{
    width: 100%;
    max-width: 768px;
    margin: 10px auto 0;
    padding-top: 20px;
    background-color: white;
  }
  .segmentation{
    height: 1px;
    width: 100%;
    box-shadow: 0 1px 0px #aaa;
    margin: 30px 0 0;
  }
  .retrieve_content{
    max-width: 610px;
    width: 410px;
    margin: 0px auto 30px;
    padding: 60px 0;
  }
  .retrieve_p{
    font-size: 14px;
    line-height: 20px;
    padding-bottom: 9px;
  }
  .input_Code{
    width: calc(100% - 130px);
    margin-right: 18px;
  }
  .btn_Code{
    width: 112px;
    padding-right: 0;
    padding-left: 0;
  }
  .btn{
    width: 100%;
    margin-top: 40px;
  }
 
</style>